import * as clsApi from "./classroomApi";
import { ClassroomDetails } from "@/stores/classroomStore_I";

type ClassroomDetailsResponseDTO = {
	result: {
		classroom: ClassroomDetails;
	};
};

export interface ClassroomDetailsResult {
	classroom: ClassroomDetails;
}

export const getClassroomDetails = async (
	classroomId: string,
	includeStudents: boolean,
	includeTeachers: boolean,
	includeRules: boolean,
	type: "CLASSROOM" | "GROUP",
	sourceId: string,
	teacherId: string
): Promise<ClassroomDetailsResult> => {
	if (type === "CLASSROOM") {
		const response = await clsApi
			.Get<ClassroomDetailsResponseDTO>(
				`classrooms/${encodeURIComponent(classroomId)}?
		includeStudents=${encodeURIComponent(includeStudents)}
		&includeTeachers=${encodeURIComponent(includeTeachers)}
		&includeRules=${encodeURIComponent(includeRules)}
		&sourceId=${encodeURIComponent(sourceId)}
		&teacherId=${encodeURIComponent(teacherId)}`
			)
			.then((data) => {
				return data.result;
			});
		return response;
	} else {
		return await clsApi
			.Get<ClassroomDetailsResponseDTO>(
				`groups/${encodeURIComponent(classroomId)}?
			includeMembers=${encodeURIComponent(includeStudents)}
			&includeOwners=${encodeURIComponent(includeTeachers)}
			&includeRules=${encodeURIComponent(includeRules)}
			&sourceId=${encodeURIComponent(sourceId)}
			&teacherId=${encodeURIComponent(teacherId)}`
			)
			.then((data) => {
				return data.result;
			});
	}
};

export const getSubgroups = async (groups: string[]): Promise<string[]> => {
	return await clsApi.Get(`subgroups?groups=${groups.join(",")}`);
};

export type CreateClassroomRequest = {
	name: string;
	isMonitoringClass: boolean;
	pinned: boolean;
};

type CreateClassroomResponse = {
	result: {
		classroom: ClassroomDetails;
	};
};

export const createClassroom = async (payload: CreateClassroomRequest): Promise<CreateClassroomResponse> => {
	const applianceId = localStorage.getItem("DEVICE");
	if (!applianceId) {
		throw new Error("Missing DEVICE in localStorage");
	}
	return clsApi.Post2(`v2/appliances/${encodeURIComponent(applianceId)}/classrooms`, payload);
};
